import { createContext, useContext } from 'react';
import { DEFAULT_WORKFLOW_RUN_STEP_VIEW_CATALOG } from './default-workflow-run-step-view-catalog';
import type { WorkflowRunStepViewCatalog } from './types';

export const WorkflowRunStepViewCatalogContext =
  createContext<WorkflowRunStepViewCatalog | null>(null);

/**
 * The active run step-view catalog. Falls back to the default JSON catalog when
 * no provider is mounted, so callers can override views per node type by
 * wrapping a subtree in {@link WorkflowRunStepViewCatalogProvider}.
 */
export function useWorkflowRunStepViewCatalog(): WorkflowRunStepViewCatalog {
  return (
    useContext(WorkflowRunStepViewCatalogContext) ??
    DEFAULT_WORKFLOW_RUN_STEP_VIEW_CATALOG
  );
}

export const WorkflowRunStepViewCatalogProvider =
  WorkflowRunStepViewCatalogContext.Provider;

export {
  DEFAULT_WORKFLOW_RUN_STEP_VIEW_CATALOG,
  DefaultRunStepView,
  resolveRunStepView,
} from './default-workflow-run-step-view-catalog';
export type {
  WorkflowRunStepView,
  WorkflowRunStepViewCatalog,
  WorkflowRunStepViewProps,
} from './types';
